import React from "react";
import { MissionType } from "@/types";
import { MissionTableRow } from "@/components";
import { useMission } from "@/hooks";
import { useTranslations } from "next-intl";

type MissionTableProps = {
  data: MissionType[];
};

function MissionTable({ data }: Readonly<MissionTableProps>) {
  const t = useTranslations("mission.MissionTable");
  const { mission } = useMission();

  return (
    <table className="table-auto w-full text-sm">
      <thead>
        <tr className="m-0 p-0 bg-muted-background">
          <th className="w-[25%] pl-6 py-3 text-left font-bold [&[align=center]]:text-center [&[align=right]]:text-right">
            {t("name")}
          </th>
          <th className="w-[35%] pl-4 py-3 text-left font-bold [&[align=center]]:text-center [&[align=right]]:text-right">
            {t("location")}
          </th>
          <th className="w-[35%] pl-4 py-3 text-left font-bold [&[align=center]]:text-center [&[align=right]]:text-right">
            {t("leadership")}
          </th>
          <th className="w-[25%] pl-4 py-3 text-left font-bold [&[align=center]]:text-center [&[align=right]]:text-right">
            {t("sites")}
          </th>
          <th className="w-[25%] px-4 py-3 text-left font-bold [&[align=center]]:text-center [&[align=right]]:text-right">
            {t("doi")}
          </th>
        </tr>
      </thead>
      <tbody>
        {!data.length && (
          <tr className="m-0 border-t p-0 text-sm">
            <td className="px-4 py-2 text-left" colSpan={5}>
              {t("notFound")}
            </td>
          </tr>
        )}
        {data.map((item) => (
          <MissionTableRow
            mission={item}
            key={item.mission_num2}
            active={item.mission_num2 == mission?.mission_num2}
          />
        ))}
      </tbody>
    </table>
  );
}

export { MissionTable };
